import { Descriptions, Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { type NutritionProfileFragment } from "../gql/generated/graphqlSchema.tsx";
import { NutrientValue } from "./NutrientValue.tsx";
import { fitContent } from "../styles/shared.styles.ts";
import { nutritionTitle, subItem } from "./NutritionInfo.styles.ts";

type NutritionInfoProps = {
  readonly nutritionProfile: NutritionProfileFragment;
  readonly title?: string | undefined;
};

export const NutritionInfo = ({ nutritionProfile: np, title = undefined }: NutritionInfoProps) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <Flex gap="middle" vertical>
      {title != null && (
        <Typography.Title className={nutritionTitle} level={5}>
          {title}
        </Typography.Title>
      )}
      <Descriptions bordered className={fitContent} column={1} size="small">
        <Descriptions.Item label={t("recipes.nutrition.energy")}>
          <NutrientValue language={lang} type="energy" unit="kJ" value={np.energyKj} /> /{" "}
          <NutrientValue language={lang} type="energy" unit="kcal" value={np.energyKcal} />
        </Descriptions.Item>
        <Descriptions.Item label={t("recipes.nutrition.fat")}>
          <NutrientValue language={lang} type="fat" unit="g" value={np.fat} />
        </Descriptions.Item>
        <Descriptions.Item label={<span className={subItem}>{t("recipes.nutrition.saturatedFat")}</span>}>
          <NutrientValue language={lang} type="saturatedFat" unit="g" value={np.saturatedFat} />
        </Descriptions.Item>
        <Descriptions.Item label={t("recipes.nutrition.carbohydrate")}>
          <NutrientValue language={lang} type="carbohydrate" unit="g" value={np.carbohydrate} />
        </Descriptions.Item>
        <Descriptions.Item label={<span className={subItem}>{t("recipes.nutrition.sugars")}</span>}>
          <NutrientValue language={lang} type="sugars" unit="g" value={np.sugars} />
        </Descriptions.Item>
        <Descriptions.Item label={t("recipes.nutrition.fibre")}>
          <NutrientValue language={lang} type="fibre" unit="g" value={np.fibre} />
        </Descriptions.Item>
        <Descriptions.Item label={t("recipes.nutrition.protein")}>
          <NutrientValue language={lang} type="protein" unit="g" value={np.protein} />
        </Descriptions.Item>
        <Descriptions.Item label={t("recipes.nutrition.salt")}>
          <NutrientValue language={lang} type="salt" unit="g" value={np.salt} />
        </Descriptions.Item>
        <Descriptions.Item label={t("ingredients.nutrition.alcohol")}>
          <NutrientValue language={lang} type="alcohol" unit="g" value={np.alcohol} />
        </Descriptions.Item>
      </Descriptions>
    </Flex>
  );
};
